export const findActiveFunction = (str, defaultOptionsOfFunctions, setUsedFunctionExamples) => {
  let extraRemoving = 0;
  let isActiveFunction = false;
  const splittedString = [...str.trim()].reduceRight(
    (acc) => {
      if (acc[acc.length - 1] === '(' && !isActiveFunction && extraRemoving === 0) {
        isActiveFunction = true;
        return acc;
      }

      if (acc[acc.length - 1] === '(' && !isActiveFunction && extraRemoving > 0) {
        extraRemoving--;
        return acc.filter((_, i) => i !== acc.length - 1);
      }

      if (acc[acc.length - 1] === ')' && !isActiveFunction) {
        extraRemoving++;
        return acc.filter((_, i) => i !== acc.length - 1);
      }

      return isActiveFunction ? acc : acc.filter((_, i) => i !== acc.length - 1);
    },
    [...str]
  );

  const string = splittedString.join('');
  const reverseString = string.split('').reverse().join('');

  const currentActiveHint = { index: Number.MAX_VALUE, value: null };

  defaultOptionsOfFunctions?.forEach((el) => {
    const revertEl = el.toLocaleLowerCase().split('').reverse().join('');
    const currentElIndex = reverseString.toLocaleLowerCase().indexOf(`(${revertEl}`);

    if (currentElIndex >= 0 && currentElIndex <= currentActiveHint.index) {
      currentActiveHint.index = currentElIndex;
      currentActiveHint.value = el;
    }
  });

  setUsedFunctionExamples(currentActiveHint.value ? [currentActiveHint.value?.toLowerCase()] : []);
};

export const getPositioningOfAddButton = () => {
  const targetElement = document.querySelector(
    '.ag-root.ag-unselectable.ag-layout-normal > button'
  );

  if (targetElement) {
    const { bottom, right } = targetElement.getBoundingClientRect();
    return { x: (bottom + 8).toFixed() + '', y: right.toFixed() - 328 + '' };
  }

  return false;
};

export const defaultOptions = [
  { value: 'blank', label: 'Blank column', type: 'String' },
  { value: 'formula', label: 'Formula', type: 'Function' },
  { value: 'iterator', label: 'Iterator Column', type: 'Iterator' },
];

export const escapeRegExp = (string) => {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
};

export const columnNameRegex = (headerName) => {
  //  the overall purpose of the regular expression is to replace headerName only in cases where it meets certain conditions: it is not contained within <span, it is not preceded by an apostrophe or quotation marks, it is not preceded by a digit, it is a standalone word, followed by a space, comma, closing parenthesis, end of line, or one of the operators, and it is not contained within <span followed by </span>.

  const regex = new RegExp(
    `(?<!<span[^>]*)(?<!["'])(?<!\\d)\\b${escapeRegExp(
      headerName
    )}\\b(?=[ ,)]|$|[+\\-*/=!><&])(?![^<]*<\\/span>)`,
    'g'
  );

  return regex;
};

export const regexFnNoClosingBraceGlobal = (fn) => {
  // This regular expression searches for places in the text where there are no letters, digits before the function name, and the function name is not enclosed between "{" and "}" symbols.
  const regex = new RegExp(`(?<![a-zA-Z0-9{])${fn}\\((?!})`, 'gi');

  return regex;
};

export const getLastVisibleColumn = (agGrid) => {
  const horizontalScrollOffset = agGrid.api.getHorizontalPixelRange().right;
  const allDisplayedColumns = agGrid.api.getAllDisplayedColumns();

  let lastVisibleColumn = allDisplayedColumns?.reduce((acc, col) => {
    const columnRight = col.getActualWidth() + col.getLeft();
    if (columnRight > horizontalScrollOffset && !acc) {
      return col;
    }
    return acc;
  }, null);

  if (!lastVisibleColumn) {
    lastVisibleColumn = allDisplayedColumns[allDisplayedColumns?.length - 1];
  }
  return lastVisibleColumn?.colDef?.colId || false;
};

export const getLastWord = (input, activeCaretIndex) => {
  const leftPartOfFormula = input.slice(0, activeCaretIndex);
  const nextCharacterAfterCaret = input.slice(activeCaretIndex, activeCaretIndex + 1);

  const specialSignRegex = /[\s\)\+\-\/\*]/;
  const isSpecialSignRegexTest = !nextCharacterAfterCaret
    ? true
    : specialSignRegex.test(nextCharacterAfterCaret);

  if (isSpecialSignRegexTest) {
    const regex = /\b(\w+)\s*$/;
    const match = leftPartOfFormula.match(regex);
    return match ? match[0] : '';
  }
  return '';
};

export const getAutocompleteList = ({
  columns = [],
  functions = [],
  currentAutocompleteValue = '',
  maxAutocompleteListLength,
}) => {
  const columnsList = columns
    .filter(({ headerName }) => {
      let _headerName = headerName;
      const specialSignRegex = /^\{.*\}$/;
      const isSpecialSignRegexTest = specialSignRegex.test(_headerName);
      if (isSpecialSignRegexTest) {
        const removeSpecialSignRegex = /^.(.*).$/;
        const result = _headerName.replace(removeSpecialSignRegex, '$1');
        _headerName = result;
      }
      return (
        currentAutocompleteValue !== _headerName &&
        _headerName.toLowerCase().startsWith(currentAutocompleteValue.toLocaleLowerCase())
      );
    })
    .map(({ headerName }) => {
      return [headerName, 'column'];
    });

  const functionsList = functions
    .filter((fn) => {
      return fn.toLowerCase().startsWith(currentAutocompleteValue.toLocaleLowerCase());
    })
    .map((fn) => {
      return [`${fn}()`, 'function'];
    });

  const autocompleteList = [...columnsList, ...functionsList];
  if (autocompleteList.length > maxAutocompleteListLength)
    autocompleteList.length = maxAutocompleteListLength;
  return autocompleteList;
};
